import React, { PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import moment from 'moment';

/**
 * Payoneer account modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const PayoneerModal = ({ account, showing, onClose }) => {
  if (!account) {
    return null;
  }

  return (
    <ModalDialog
      modalOpen={showing}
      dialogClasses="payoneer-account"
      modalHeader="Edit Payonner account"
      closeAction={onClose}
      primaryLabel="Got it"
      onPrimary={onClose}
    >
      { account.updated &&
      <p className="account-last-updated">
        This account was last updated on { moment(account.updated).format('MMM DD, h:mm a') }.
      </p> }
      <p>
        In order to edit your Payoneer account details,
        please <a target="_blank" href="https://myaccount.payoneer.com/">visit their website</a>.
      </p>
    </ModalDialog>
  )
}

/**
 * PropTypes.
 *
 * @property {object} account - account being edited
 * @property {bool} showing - whether to show this modal
 * @property {func} onClose - called to close this modal
 */
PayoneerModal.propTypes = {
  account: PropTypes.object,
  showing: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PayoneerModal;



// WEBPACK FOOTER //
// ./account/components/payout/payoneer_modal.jsx